  (function () {
    function overrideLoginButton() {
      if (document.body.dataset.whLoginOverride === 'true') return;
      document.body.dataset.whLoginOverride = 'true';

      document.addEventListener(
        'click',
        function (e) {
          const btn = e.target.closest('.wishlist-hero-list-header-login');

          if (!btn) return;

          e.preventDefault();
          e.stopImmediatePropagation();

          window.location.href = 'https://ustabelle.co.il/account/login';
        },
        true
      );
    }

    function moveCopyButtonToSocials() {
      const copyBtn = document.querySelector('button.MuiButton-root[aria-label="COPY"]');
      const socialWrap = document.querySelector('.wishlist-hero-share-icons');

      if (!copyBtn || !socialWrap || copyBtn.dataset.movedToWrap === 'true') return;

      const copyItem = document.createElement('div');
      copyItem.className = 'jss6 wh-copy-social-item';
      copyItem.appendChild(copyBtn);

      socialWrap.appendChild(copyItem);
      copyBtn.dataset.movedToWrap = 'true';
    }

    function cleanWishlistHeaderCount() {
      document.querySelectorAll('.wishlist-hero-items-count').forEach(el => el.remove());

      document.querySelectorAll('.wishlist-hero-header-icon').forEach(el => {
        el.style.visibility = 'visible';
      });
    }

    function fixWishlistInlineFonts() {
      document.querySelectorAll('h1.wishlist-hero-page-header').forEach(el => {
        el.style.setProperty(
          'font-family',
          'var(--heading-font-family), sans-serif',
          'important'
        );
      });

      document.querySelectorAll('.wishlist-hero-list-card-header-product-name').forEach(el => {
        el.style.setProperty(
          'font-family',
          'var(--text-font-family), sans-serif',
          'important'
        );
      });
    }

    function runWishlistHeroOverrides() {
      overrideLoginButton();
      moveCopyButtonToSocials();
      cleanWishlistHeaderCount();
      fixWishlistInlineFonts();
    }

    document.addEventListener('DOMContentLoaded', function () {
      runWishlistHeroOverrides();

      const observer = new MutationObserver(runWishlistHeroOverrides);

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    });
  })();
